import {v4 as uuidv4} from 'uuid';

export default {
    render(data, event) {
        const form = document.createElement('form');
        form.id = `form-group-${data.id || uuidv4()}`;

        return form;
    },
    postRender() {}
};